import React, { useState } from "react";
import "./Navbar.css";
import { useNavigate, useLocation } from "react-router-dom";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/login"); // Navigate to login or home page
    setMenuOpen(false);
  };

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  return (
    <>
      {/* 🌊 Top Navbar */}
      <nav className="navbar">
        <div className="navbar-left">
          <h1 className="logo">Smart Gate</h1>
        </div>

        <div className="navbar-right">
          {/* Logout Button */}
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>

          {/* 3-dot Menu Button */}
          <button
            className={`menu-btn ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </button>
        </div>
      </nav>

      {/* 📱 Mobile Slide Menu */}
      <div
        className={`mobile-menu ${menuOpen ? "active" : ""}`}
        onClick={(e) => {
          if (e.target.classList.contains("mobile-menu")) setMenuOpen(false);
        }}
      >
        <div className="menu-header">
          <h2>Menu</h2>
          <button
            className="close-btn"
            onClick={() => setMenuOpen(false)}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <ul className="menu-links">
          <li
            className={location.pathname === "/admin" ? "active" : ""}
            onClick={() => handleNavigate("/admin")}
          >
            Dashboard
          </li>
          <li
            className={location.pathname === "/admin/users" ? "active" : ""}
            onClick={() => handleNavigate("/admin/users")}
          >
            Users
          </li>
          <li
            className={location.pathname === "/admin/guards" ? "active" : ""}
            onClick={() => handleNavigate("/admin/guards")}
          >
            Guards
          </li>
          <li
            className={location.pathname === "/admin/society" ? "active" : ""}
            onClick={() => handleNavigate("/admin/society")}
          >
            Society
          </li>
          <li
            className={location.pathname === "/admin/reports" ? "active" : ""}
            onClick={() => handleNavigate("/admin/reports")}
          >
            Visitors
          </li>
          <li
            className={location.pathname === "/admin/createstaff" ? "active" : ""}
            onClick={() => handleNavigate("/admin/createstaff")}
          >
            Create Staff
          </li>
          <li
            className={location.pathname === "/admin/allstaff" ? "active" : ""}
            onClick={() => handleNavigate("/admin/allstaff")}
          >
            All Staffs
          </li>
          <li
            className={location.pathname === "/admin/staffAttendence" ? "active" : ""}
            onClick={() => handleNavigate("/admin/staffAttendence")}
          >
            Staff Attendances
          </li>
          <li onClick={handleLogout}>Logout</li>
        </ul>
      </div>
    </>
  );
}

export default Navbar;
